module.exports = __webpack_public_path__ + "static/img/1.6683df4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/sp/1.png
// module id = YB1v
// module chunks = 0